module.exports = __webpack_public_path__ + "img/icb-opening-04.9657b441.png";